import { render, staticRenderFns } from "./department_manager.vue?vue&type=template&id=21f63b11&scoped=true"
import script from "./department_manager.vue?vue&type=script&lang=js"
export * from "./department_manager.vue?vue&type=script&lang=js"
import style0 from "./department_manager.vue?vue&type=style&index=0&id=21f63b11&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f63b11",
  null
  
)

export default component.exports